import {
  Box,
  HStack,
  Heading,
  IconButton,
  SimpleGrid,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import EditTimelineModal from "./EditTimelineModal";
import dayjs, { Dayjs, UnitType } from "dayjs";
import { KYDAdminEvent } from "@common/interfaces/KYDEvent";
import { EditModalType, formatDate } from "../utils";
import { FiEdit2 } from "react-icons/fi";

const Stat = ({ label, value, headerSize, subtext, ...boxProps }) => {
  return (
    <Box
      px={{ base: "4", md: "4" }}
      py={{ base: "5", md: "4" }}
      bg="bg-surface"
      borderRadius="lg"
      borderWidth={"1px"}
      borderColor="gray.200"
      {...boxProps}
    >
      <Stack>
        <Text fontSize="sm" color="muted">
          {label}
        </Text>
        <Heading size={headerSize}>{value}</Heading>
        {subtext ? <Text fontSize={"xs"}>{subtext}</Text> : null}
      </Stack>
    </Box>
  );
};

const translations = {
  announce_at: "📢 Announce on",
  on_sale_at: "💰 On sale",
  off_sale_at: "🛑 Off sale",
  start_at: "🎬 Event start",
  end_at: "🏁 Event end",
  doors_at: "🚪 Doors open",
};

const generateDiffString = (dateTo: Dayjs, eventStartsDate: Dayjs) => {
  const diff = eventStartsDate?.to(dateTo, true);
  const numericalDiff = eventStartsDate?.diff(dateTo, "ms");

  if (!diff) return;

  let when = numericalDiff > 0 ? "after" : "before";

  return `${diff} ${when} the event starts.`;
};

const TimelineSection = ({
  kydEvent,
  isOpen,
  onSave,
  onCancel,
  setModalType,
  loading,
}: {
  kydEvent: KYDAdminEvent;
  isOpen: boolean;
  onSave: (data: any) => any;
  onCancel: () => void;
  setModalType: (modal: EditModalType) => void;
  loading: any;
}) => {
  const dates = [
    "announce_at",
    "on_sale_at",
    "doors_at",
    "start_at",
    "off_sale_at",
    "end_at",
  ];
  //@ts-ignore
  // kydEvent.off_sale_at = new Date(2024, 0, 24, 16);
  const openEditModal = () => setModalType(EditModalType.TIMELINE);
  return (
    <>
      <EditTimelineModal
        isLoading={loading.event}
        kydEvent={kydEvent}
        isOpen={isOpen}
        onCancel={onCancel}
        onSave={onSave}
      />
      <VStack alignItems={"flex-start"} w="full" gap={1}>
        <HStack>
          <Heading size="sm">Timeline</Heading>
          <IconButton
            // isDisabled={loading["blocking"]}
            variant={"ghost"}
            aria-label="Add affiliates"
            icon={<FiEdit2 fontSize="1.25rem" />}
            onClick={() => openEditModal()}
          />
        </HStack>
        <Stack w="100%" align={"flex-end"}>
          <SimpleGrid w="100%" columns={{ base: 1, md: 3 }} gap="6">
            {dates.map((date) => (
              <Stat
                onClick={() => openEditModal()}
                key={date}
                cursor="pointer"
                headerSize={"sm"}
                label={translations[date]}
                subtext={
                  !["start_at"].includes(date)
                    ? generateDiffString(
                        dayjs(kydEvent.start_at),
                        kydEvent[date] ? dayjs(kydEvent[date]) : null
                      )
                    : null
                }
                value={
                  kydEvent[date]
                    ? `${formatDate(dayjs(kydEvent[date]).tz(kydEvent.timezone))}`
                    : "Not set"
                }
              />
            ))}
          </SimpleGrid>
        </Stack>
      </VStack>
    </>
  );
};

export default TimelineSection;
